import { useTranslation } from "next-i18next";
import React from "react";

import { TermOfPaymentItem } from "./TermOfPaymentItem";

import type { Account } from "../types/ContactTypes";
import type { ErrorMap } from "@repo/shared/common";
import type { SetStateAction } from "react";

type ContactTermsOfPaymentProps = {
	contact: Account;
	setContact: (value: SetStateAction<Account>) => void;
	errors?: ErrorMap;
	setErrors?: (value: SetStateAction<ErrorMap>) => void;
};

export const ContactTermsOfPayment = (props: ContactTermsOfPaymentProps) => {
	const { t } = useTranslation();

	const { contact, setContact, errors, setErrors } = props;

	if (contact.termsOfPaymentEntries == null || contact.termsOfPaymentEntries.length === 0) {
		return null;
	}

	return (
		<div>
			<div className="hrTitle lightGreyFont" style={{ marginBottom: 25 }}>
				<span className="left">{t("terms-of-payment").toLocaleUpperCase()}</span>
				<hr className="right" />
			</div>
			<div className="clear paddingBottom40" />
			{contact.termsOfPaymentEntries.map((entry, index) => (
				<>
					<TermOfPaymentItem
						key={entry.id}
						term={entry}
						index={index}
						contact={contact}
						setContact={setContact}
						errors={errors}
						setErrors={setErrors}
					/>
					{index !== contact.termsOfPaymentEntries.length - 1 && (
						<hr style={{ marginBottom: 25, marginTop: 25 }} />
					)}
				</>
			))}
		</div>
	);
};
